import { render } from "./NonexistentDomain.vue?vue&type=template&id=5a37047c&ts=true"
import script from "./NonexistentDomain.vue?vue&type=script&lang=ts"
export * from "./NonexistentDomain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__